export const Colors = {
    grey: "#F3F3F3",
    grey2: "#E5E5E5",
    red: "#F0613D",
    darkGrey: "#4C4B4E",
    white: "#FFFFFF"
};
